import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-show-system-log-filter',
  templateUrl: './show-system-log-filter.component.html',
  styleUrls: ['./show-system-log-filter.component.scss'],
  imports: [CommonModule, MatIconModule, MatSlideToggleModule, MatTooltipModule],
})
export class ShowSystemLogFilterComponent implements OnInit {
  filtersForm = input<FormGroup>();
  title = input<string>();

  showSystemLog = false;
  destroyRef = inject(DestroyRef);
  ngOnInit() {
    this.showSystemLog = this.filtersForm().get('showSystemLog').value;

    this.filtersForm()
      .get('showSystemLog')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        if (value === null) this.showSystemLog = false;
      });
  }

  toggle() {
    this.showSystemLog = !this.showSystemLog;
    this.filtersForm().get('showSystemLog').setValue(this.showSystemLog);
  }
}
